<template>
  <div class="invoiceTable">
    <slot-table :data="tableData" :columns="table.columns">

      <template slot="client" slot-scope="props">
        <span>
          <router-link :to="{ path: `/client/${props.item.client.hash_id}` }">
            {{ props.item.client.name }}
          </router-link>
        </span>
      </template>

      <template slot="period_start" slot-scope="props">
        <span>{{ props.item.period_start.value | formatDate }} - {{ props.item.period_end.value | formatDate }}</span>
      </template>

      <template slot="status" slot-scope="props">
        <span class="text-capitalize">{{ props.item.status }}</span>
      </template>

      <template slot="amount" slot-scope="props">
        <span><span
            v-html="currencySymbol(props.item.currency)"/>{{ delimitNumbers(props.item.summary.total_to_be_invoiced) }}</span>
      </template>

      <template slot="adjustment" slot-scope="props">
        <span><span v-html="currencySymbol(props.item.currency)"/>{{ delimitNumbers(props.item.summary.total_adjustments) }}</span>
      </template>

      <template slot="pdf" slot-scope="props">
        <a v-if="props.item.download_url" :href="downloadUrl(props.item.download_url)" class="btn btn-primary btn-xs" target="_blank">
          <i class="fa fa-file-pdf-o"></i>
        </a>
        <router-link class="btn btn-warning btn-xs" :to="{ path: `/invoice/full/${props.item.hash_id}` }">
          <i class="fa fa-file-text"></i>
        </router-link>
      </template>

    </slot-table>
  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {invoiceMixin} from '@/mixins/invoiceMixin'

export default {
  name: 'InvoiceTable',
  mixins: [invoiceMixin],
  components: {
    SlotTable,
    ButtonCta,
    Field,
    SwitchButton,
    Checkbox,
    Heading
  },
  props: {
    tableData: Array
  },
  data: () => ({
    table: {
      columns: {
        external_id: 'Number',
        client: 'Client',
        period_start: 'Period',
        status: 'Status',
        amount: 'Amount',
        adjustment: 'Adjustment',
        pdf: 'PDF'
      }
    }
  }),
  methods: {}
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/InvoiceTable/invoice-table.vue